import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
} from "antd";
import CustomDateTimePicker from "../common/CustomDateTimePicker";
import { useGoBack } from "../customHooks/useGoBack";
import {
  ContainerLoadTypeSelect,
  ForwarderSelect,
  SupplierOrgSelect,
  validateNonNegativeNumber,
} from "../helpers/common";
import ContainerService from "../services/Container/ContainerService";
import WarehouseSelect from "../components/WarehouseSelect";
import AppButton from "../common/AppButton";

const { TextArea } = Input;

const NewShipment = () => {
  const [form] = Form.useForm();
  const goBack = useGoBack();

  const handleClose = () => {
    goBack();
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const request = {
        ...values,
        eta: values.eta?.format("YYYY-MM-DDTHH:mm"),
      };
      const response = await ContainerService.saveContainer(request);

      if (response?.status === 200) {
        message.success("Shipment Added Successfully");
        form.resetFields();

        // Show info modal
        Modal.info({
          title: "Container Tracking Initiated",
          content: (
            <div>
              <p>Container Tracking has been initiated.</p>
              <p>
                Shipment details and status event updates will be updated once
                they are received.
              </p>
            </div>
          ),
          onOk() {
            goBack();
          },
        });
      }
    } catch (error) {
      message.error(error?.response?.data?.message || "Something went wrong.");
    }
  };
  return (
    <Form form={form} layout="vertical" className="px-8 relative mb-4">
      <div className="flex justify-start items-center w-full my-2  mx-2 font-inter">
        <span className="!font-medium text-[30px] !text-[#015373] !m-0 pl-4 mt-10">
          New Shipment
        </span>
        <div className="mx-2 flex items-center justify-end pr-4 pt-2 h-full">
          {/* <Link to={`/`} className="text-md font-medium text-[#01A4A6]">
            {" "}
            / Shipment Gateway
          </Link> */}
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
        <Card className="pb-1 rounded-3xl shadow-xl bg-white bg-opacity-80 grid grid-cols-1 col-span-3">
          <div className=" mt-2 grid grid-cols-1 lg:grid-cols-2 gap-x-[33%] gap-y-0  ml-4 mr-8">
            {" "}
            <Form.Item
              label="Container Number"
              name="number"
              rules={[
                {
                  required: true,
                  message: "Please enter the container number",
                },
              ]}
            >
              <Input className="h-[34px]" />
            </Form.Item>
            <Form.Item
              label="BL/Reference Number"
              name="mblNum"
              rules={[
                {
                  required: true,
                  message: "Please enter the BL/Reference Number",
                },
              ]}
            >
              <Input className="h-[34px]" />
            </Form.Item>
            <Form.Item
              name="eta"
              label="ETA"
              rules={[{ required: true, message: "Please Select ETA Date" }]}
            >
              <CustomDateTimePicker
                type="date"
                form={form}
                itemName="eta"
                className="w-full h-[34px]"
              />
            </Form.Item>
            <Form.Item
              label="User Reference"
              name="userReference"
              rules={[
                { required: true, message: "Please input the user reference!" },
              ]}
            >
              <Input className="h-[34px]" />
            </Form.Item>
          </div>
          <div className="ml-4 mr-8">
            <div className="w-[100%] flex items-center">
              <Form.Item
                label="Forwarder"
                name="forwarder"
                rules={[{ required: true, message: "Please Select Forwarder" }]}
                className="w-[66%] mr-2"
              >
                <ForwarderSelect
                  selectClassNames="h-[34px]"
                  autoSelectFirst
                  onForwarderChange={(forwarder) => {
                    form.setFieldsValue({
                      detentionFreeDays: forwarder?.detentionFreeDays ?? 0
                    });
                  }}
                />
              </Form.Item>
              <Form.Item
                name="detentionFreeDays"
                label="Detention Free Days"
                style={{ width: "20%" }}
              >
                <InputNumber
                  controls={false}
                  min={0}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                      "Home",
                      "End",
                    ];
                    const isNumberKey = e.key >= "0" && e.key <= "9";
                    const isAllowed =
                      isNumberKey || allowedKeys.includes(e.key);

                    if (!isAllowed) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </div>

            <Form.Item
              name="supplierID"
              label="Supplier"
              rules={[{ required: true, message: "Please Select Supplier" }]}
              className="w-[66%]"
            >
              <SupplierOrgSelect selectClassNames="h-[34px]" form={form} />
            </Form.Item>
            <Form.Item
              name="containerLoadType"
              label="Container Load Type"
              rules={[
                {
                  required: true,
                  message: "Please Select Container Load Type",
                },
              ]}
              className="w-[66%]"
            >
              <ContainerLoadTypeSelect selectClassNames="h-[34px]" autoSelectFirst />
            </Form.Item>
          </div>
        </Card>
        <Card className="pb-1 rounded-3xl shadow-xl bg-white bg-opacity-80 grid grid-cols-1 col-span-2">
          <div className=" mt-2 grid grid-cols-1 gap-x-[33%]  ml-4 mr-8">
            <Form.Item label="Warehouse"
              name="warehouseId"
              rules={[{ required: true, message: "Please select warehouse" }]}
            >
              <WarehouseSelect size="middle" />
            </Form.Item>
            <div className="flex justify-between w-[75%]">
              <Form.Item
                label="Boxes"
                name="boxes"
                rules={[{ validator: validateNonNegativeNumber(false) }]}
              >
                <InputNumber
                  className="h-[34px]"
                  controls={false}
                  min={0}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                      "Home",
                      "End",
                    ];
                    const isNumberKey = e.key >= "0" && e.key <= "9";
                    const isAllowed =
                      isNumberKey || allowedKeys.includes(e.key);

                    if (!isAllowed) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
              <Form.Item
                label="Pallets"
                name="pallets"
                rules={[{ validator: validateNonNegativeNumber(false) }]}
              >
                <InputNumber
                  className="h-[34px]"
                  controls={false}
                  min={0}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                      "Home",
                      "End",
                    ];
                    const isNumberKey = e.key >= "0" && e.key <= "9";
                    const isAllowed =
                      isNumberKey || allowedKeys.includes(e.key);

                    if (!isAllowed) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </div>

            <Form.Item
              label="Contents"
              name="contents"
              rules={[
                { required: true, message: "Please input the contents!" },
                { max: 20, message: "Contents must be at most 20 characters." },
              ]}
            >
              <Input className="h-[34px]" />
            </Form.Item>

            <Form.Item label="Notes" name="notes">
              <TextArea rows={8} />
            </Form.Item>
          </div>
        </Card>
        <Row gutter={16}>
          <Col span={5}></Col>
          <Col span={6}></Col>
          {/* <Col span={3}>
            <Form.Item
              name="containerType"
              label="Type"
              rules={[
                { required: true, message: "Please Select Container Type" },
              ]}
            >
              <Select placeholder="Select Container Type" size="large">
                {["20GP", "40GP", "40HC", "45HC", "LCL"].map((type, index) => (
                  <Select.Option key={index} value={type}>
                    {type}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col> */}
          {/* <Col span={8}></Col>
        <Col span={5}>
          <Form.Item label="Status">
            <Input size="large" value="Shipment Finalised" />
          </Form.Item>
        </Col> */}
        </Row>

        <Row gutter={16}>
          {/* <Col span={6}>
            <Form.Item
              name="cargoReadyDate"
              label="Cargo Ready Date"
              rules={[
                { required: true, message: "Please Select Cargo Ready Date" },
              ]}
            >
              <DatePicker
                className="w-full"
                placeholder="Select Cargo Ready Date"
                format="DD MMM YYYY"
                size="large"
              />
            </Form.Item>
          </Col> */}
          <Col span={4}></Col>
          <Col span={8}></Col>
          <Col span={5}></Col>
          <Col span={7}></Col>
          {/* <Col span={4}>
            <Form.Item label="Port of Loading" name="portOfLoading">
              <Input placeholder="Port of Loading" size="large" />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="Port of Discharge" name="portOfDischarge">
              <Input placeholder="Port of Discharge" size="large" />
            </Form.Item>
          </Col> */}
        </Row>

        <Row gutter={16}>
          <Col span={2}></Col>
          {/* <Col span={6}>
            <Form.Item
              label="Unload Man Hours"
              name="boxesUnloadManHours"
              rules={[{ validator: validateNonNegativeNumber(true) }]}
            >
              <InputNumber
                controls={false}
                placeholder="Hours"
                size="large"
                min={0}
                precision={2}
                onKeyDown={(e) => {
                  const allowedKeys = [
                    "Backspace",
                    "Delete",
                    "ArrowLeft",
                    "ArrowRight",
                    "Tab",
                    "Home",
                    "End",
                  ];
                  const isNumberKey = e.key >= "0" && e.key <= "9";
                  if (e.key === ".") {
                    if (e.currentTarget.value.includes(".")) {
                      e.preventDefault();
                    }
                    return;
                  }

                  const isAllowed = isNumberKey || allowedKeys.includes(e.key);

                  if (!isAllowed) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col> */}
          <Col span={2}></Col>
          {/* <Col span={6}>
            <Form.Item
              label="Unload Man Hours"
              name="palletsUnloadManHours"
              rules={[{ validator: validateNonNegativeNumber(true) }]}
            >
              <InputNumber
                controls={false}
                placeholder="Hours"
                size="large"
                min={0}
                precision={2}
                onKeyDown={(e) => {
                  const allowedKeys = [
                    "Backspace",
                    "Delete",
                    "ArrowLeft",
                    "ArrowRight",
                    "Tab",
                    "Home",
                    "End",
                  ];
                  const isNumberKey = e.key >= "0" && e.key <= "9";
                  if (e.key === ".") {
                    if (e.currentTarget.value.includes(".")) {
                      e.preventDefault();
                    }
                    return;
                  }

                  const isAllowed = isNumberKey || allowedKeys.includes(e.key);

                  if (!isAllowed) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col> */}
          <Col span={20}></Col>
        </Row>
      </div>
      <div className="flex justify-end mr-8">
        <AppButton variant="save" onClick={handleSubmit}>
          Save
        </AppButton>
        <AppButton variant="close" onClick={handleClose}>
          Close
        </AppButton>
      </div>
    </Form>
  );
};

export default NewShipment;
